import { desktopAccountSession } from '@/lib/utils/native-credential-store'
import { desktopSecureStorage, isTauri } from '@/lib/utils/tauri'

import { SessionChangedError } from '@scrambl/shared/session-scope'

import type { CacheOwner } from './cache-scope'

/** Capture before any cache-open await; a stale webview cannot adopt the new
 * storage generation using the removed login's cache key. */
export function captureNativeCacheSession(owner: CacheOwner) {
  if (!isTauri()) return null
  const expected = desktopAccountSession.capture()
  if (
    !expected.identity ||
    expected.identity !== owner.userId ||
    owner.login !==
      JSON.stringify([
        'desktop',
        expected.identity,
        expected.credentialSessionKey,
      ])
  )
    throw new SessionChangedError()
  return {
    assertCurrent: expected.assertCurrent,
    async verify() {
      await desktopSecureStorage.assertSessionCurrent(expected)
      expected.assertCurrent()
    },
  }
}
